import { AssetGroupStore } from './asset-group.store';
import { AssetTypeStore } from './asset-type.store';
import { AssetStore } from './asset.store';
import { CampaignInfoStore } from './campaign-info.store';
import { CampaignMeasureStore } from './campaign-measure.store';
import { CampaignModelStore } from './campaign-model.store';
import { CampaignStore } from './campaign.store';
import { InfoStore } from './info.store';
import { LogStore } from './log.store';

const ASSET_MANAGEMENT_PROVIDERS = [AssetTypeStore, AssetStore, AssetGroupStore];

const CAMPAIGN_MANAGEMENT_PROVIDERS = [
  CampaignStore,
  CampaignMeasureStore,
  CampaignInfoStore,
  CampaignModelStore,
  InfoStore,
  LogStore,
];

export const ALL_STORE_PROVIDERS = [...ASSET_MANAGEMENT_PROVIDERS, ...CAMPAIGN_MANAGEMENT_PROVIDERS];
